import React, {PureComponent} from 'react';
import _ from 'lodash';

import ReservesSystemInfo from '../../components/ReservesSystem/ReservesSystemInfo';
import {IProps} from './IReservesSystemInfo';

class ReservesSystemInfoCont extends PureComponent<IProps, any> {
  /** @description Запрос расписания ресторана */
  componentDidMount() {
    const {currentRestaurant, getScheduleList} = this.props;
    if (currentRestaurant) {
      getScheduleList(currentRestaurant.id);
    }
  }

  /** @description Запрос расписания ресторана в случае изменения текущего ресторана */
  componentDidUpdate(prevProps: any) {
    const {currentRestaurant, getScheduleList} = this.props;

    if (currentRestaurant && _.isUndefined(prevProps.currentRestaurant)) {
      getScheduleList(currentRestaurant.id);
    } else if (currentRestaurant && currentRestaurant.id !== prevProps.currentRestaurant.id) {
      getScheduleList(currentRestaurant.id);
    }
  }

  /** @description Ручка для экшена для редактирования информации у выбранного ресторана */
  handleUpdateRestaurant = (info: {
    value: string | number, type: any
  }) => {
    const {currentRestaurant, updateRestaurantInfo} = this.props;

    if (currentRestaurant) {
      const updateData = {
        ...info,
        currentRestaurant,
      };

      updateRestaurantInfo(updateData);
    }
  };

  render() {
    const {
      currentRestaurant,
    } = this.props;

    if (!currentRestaurant) {
      return null;
    }

    return (
      <ReservesSystemInfo
        currentRestaurant={currentRestaurant}
        updateRestaurant={this.handleUpdateRestaurant}
      />
    );
  }
}

export default ReservesSystemInfoCont;
